module.exports = __webpack_public_path__ + "static/img/user_1.7b4d248.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_1.jpg
// module id = s12Y
// module chunks = 1